/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Too_Many_Lines_TitleInputs */

const en_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too Many Lines`)
};

const fr_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de lignes`)
};

const de_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Zeilen`)
};

const it_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppe linee`)
};

const ru_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слишком много строк`)
};

const es_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas líneas`)
};

const zh_cn2_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行数太多`)
};

const ja_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行が多すぎる`)
};

const hi_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बहुत ज्यादा पंक्तियाँ`)
};

const pt_pt2_embed_captions_too_many_lines_title = /** @type {(inputs: Embed_Captions_Too_Many_Lines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas em Excesso`)
};

/**
* | output |
* | --- |
* | "Too Many Lines" |
*
* @param {Embed_Captions_Too_Many_Lines_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_too_many_lines_title = /** @type {((inputs?: Embed_Captions_Too_Many_Lines_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Too_Many_Lines_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_too_many_lines_title(inputs)
	if (locale === "de") return de_embed_captions_too_many_lines_title(inputs)
	if (locale === "it") return it_embed_captions_too_many_lines_title(inputs)
	if (locale === "ru") return ru_embed_captions_too_many_lines_title(inputs)
	if (locale === "es") return es_embed_captions_too_many_lines_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_too_many_lines_title(inputs)
	if (locale === "ja") return ja_embed_captions_too_many_lines_title(inputs)
	if (locale === "hi") return hi_embed_captions_too_many_lines_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_too_many_lines_title(inputs)
	return en_embed_captions_too_many_lines_title(inputs)
});